import React, { useState, useEffect } from "react";
import { useGlobalContext } from "../context";

const Hero = () => {
  const { allImages } = useGlobalContext();
  const [index, setIndex] = useState(0);
  const [image, setImage] = useState(allImages[index]);

  useEffect(() => {
    const id = setInterval(() => {
      if (index < allImages.length) {
        setImage(allImages[index]);
        setIndex(index + 1);
      } else {
        setIndex(0);
      }
    }, 3000);

    return () => {
      clearInterval(id);
    };
  });

  return (
    <section className="section hero">
      <img className="hero-img" src={image} alt="Meal" />
      <h1 className="hero-txt">Let Us Worry About What You Will Eat</h1>
    </section>
  );
};

export default Hero;
